module.exports = __webpack_public_path__ + "img/prove1.f419c0f0.png";